exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delivery-area .map-toolbar[data-v-64f27742]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;margin-bottom:10px;padding:0 5px}.delivery-area .tencent-map[data-v-64f27742]{width:100%;height:500px;border:1px solid #e0e0e0;border-radius:4px}", ""]);

// exports
